var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWoocommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F54B3",
    d: "M6 0h36a6 6 0 0 1 6 6v14a6 6 0 0 1-6 6H22l3 6-9-6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 8.6c.3-.5.8-.8 1.4-.8.9 0 1.4.4 1.6 1.3.3 2 .7 3.7 1 5.2l2-3.9c.3-.5.6-.8 1.1-.8.7 0 1.1.4 1.3 1.3.3 1.6.5 3 .9 4.3.3-2.8.8-4.9 1.5-6.2.2-.4.6-.6 1.1-.6.4 0 .7.1 1 .4.3.2.4.5.5.9 0 .3 0 .5-.2.8-.9 1.7-1.6 4.5-2.2 8.3-.1.5-.4.8-.9.8-.6 0-1-.4-1.3-1.2-.4-1.3-.7-2.5-.9-3.6-.5 1-.9 1.8-1.2 2.4-.6 1.1-1 1.7-1.4 1.8-.5.1-1-.3-1.4-1.2-.6-1.5-1.1-4.1-1.7-7.6-.1-.5 0-.9.3-1.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 8.5c1 0 1.7.5 2 1.4.2.6.3 1.3.3 2 0 1.4-.3 2.7-.9 3.8-.7 1.3-1.6 2-2.6 2-.2 0-.4 0-.6-.1-.9-.2-1.6-.7-2-1.6-.2-.6-.3-1.3-.3-2 0-1.4.3-2.7.9-3.8.7-1.2 1.5-1.7 2.6-1.7Zm.5 4.9c.3-.7.4-1.4.4-2 0-.2-.1-.5-.2-.7-.1-.3-.3-.5-.6-.5-.4 0-.8.3-1.1 1-.3.6-.4 1.3-.4 1.9 0 .2.1.5.2.7.1.3.3.5.6.5.4 0 .8-.4 1.1-1Zm7.9-4.9c1 0 1.7.5 2 1.4.2.6.3 1.3.3 2 0 1.4-.3 2.7-.9 3.8-.7 1.3-1.6 2-2.6 2-.2 0-.4 0-.6-.1-.9-.2-1.6-.7-2-1.6-.2-.6-.3-1.3-.3-2 0-1.4.3-2.7.9-3.8.7-1.2 1.5-1.7 2.6-1.7Zm.5 4.9c.3-.7.4-1.4.4-2 0-.2-.1-.5-.2-.7-.1-.3-.3-.5-.6-.5-.4 0-.8.3-1.1 1-.3.6-.4 1.3-.4 1.9 0 .2.1.5.2.7.1.3.3.5.6.5.4 0 .8-.4 1.1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWoocommerce);
export default __webpack_public_path__ + "static/media/logo-woocommerce.e9da00113ede695f411fc3146ca5a634.svg";
export { ForwardRef as ReactComponent };